import e from"react";import r from"../../../../external/classnames/index.js";const t=({children:t,className:a=""})=>{const s=r("card-footer",a);return e.createElement("div",{className:s},t)};export{t as CardFooter};
//# sourceMappingURL=CardFooter.js.map
